import { AdvisorClientLatestOpportunityStatusData } from "@/models/AdvisorClientLatestOpportunityStatusData";
import { ClientStatistics } from "@/models/ClientStatistics";
import { OpportunityStatusService } from "@/services/OpportunityStatusService";
import store from "@/store";
import { Module } from "vuex-class-modules";
import { BaseParentDocumentStore } from "./BaseParentDocumentStore";

@Module({ generateMutationSetters: true })
class OpportunityStatusStore extends BaseParentDocumentStore<
  AdvisorClientLatestOpportunityStatusData,
  OpportunityStatusService
> {
  current: AdvisorClientLatestOpportunityStatusData = new AdvisorClientLatestOpportunityStatusData();
  service: OpportunityStatusService = new OpportunityStatusService();
  stats: ClientStatistics[] = [];

  newEntity(): AdvisorClientLatestOpportunityStatusData {
    return new AdvisorClientLatestOpportunityStatusData();
  }

}

export const opportunityStatusStore = new OpportunityStatusStore({
  store,
  name: "opportunityStatusStore",
});
